import { render, staticRenderFns } from "./ProducttypeTable.vue?vue&type=template&id=500e70c6&scoped=true&lang=pug&"
import script from "./ProducttypeTable.vue?vue&type=script&lang=js&"
export * from "./ProducttypeTable.vue?vue&type=script&lang=js&"
import style0 from "./ProducttypeTable.vue?vue&type=style&index=0&id=500e70c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e70c6",
  null
  
)

export default component.exports